import replicaAPI from "../../api/replicaApi";

const callApi = async (endpoint) => {
  try {
    const response = await replicaAPI.get(endpoint);
    if (response.status === 200) {
      return response?.data;
    } else {
      return response;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export const coinPaymentService = {
  getCoins: async () => {
    const response = await callApi("get-coins");
    return response;
  },
  getAdminCoinId:
    async () => {
      const response = await callApi("get-admin-coinid");
      return response;
    },
}